import listeningTogether from './listening-together.webp';
import forest from './forest.webp';
import familySmiling from './family-smiling.webp';
import guyListeningWithHeadphones from './guy-listening-headphones.webp';
import manListeningIntently from './man-listening-intently.webp';
import headphones from './headphones.webp';
import earCloseUp from './ear-close-up.webp';
import earWithSoundWaves from './ear-with-soundwaves.webp';
import normalHearingIcon from './normal.webp';
import mildHearingIcon from './mild.webp';
import severeHearingIcon from './severe.webp';
import family from './family.webp';
import womanWithTablet from './woman-with-tablet.webp';
import calendar from './calendar.webp';
import ear from './ear.webp';
import laptop from './laptop.webp';
import manReadsBook from './man-reads-book.webp';
import officePeople from './office-people.webp';
export var pageImages = {
    guyListeningWithHeadphones: guyListeningWithHeadphones,
    listeningTogether: listeningTogether,
    forest: forest,
    familySmiling: familySmiling,
    manListeningIntently: manListeningIntently,
    headphones: headphones,
    earCloseUp: earCloseUp,
    earWithSoundWaves: earWithSoundWaves,
    normalHearingIcon: normalHearingIcon,
    mildHearingIcon: mildHearingIcon,
    severeHearingIcon: severeHearingIcon,
    family: family,
    womanWithTablet: womanWithTablet,
    calendar: calendar,
    ear: ear,
    laptop: laptop,
    manReadsBook: manReadsBook,
    officePeople: officePeople,
};
